import React, { useState } from "react";

import PropTypes from "prop-types";
import { IconButton } from "@chakra-ui/react";
import { isPositiveInteger } from "../../../Library/validations";

const CounterInput = ({ labelClassName, label, counterContainer, counterButton, counterDisplay, onChange, inputName, defaultValue, errMessage, minValue, maxValue, showAmount }) => {
  const [count, setCount] = useState(defaultValue || 1);

  const setPositiveCount = (val) => {
    if (isPositiveInteger(val) || !val) {
      if (val && minValue && val < minValue) val = minValue;
      if (val && maxValue && val > maxValue) val = maxValue;

      setCount(Number(val));
      onChange(Number(val));
    }
  };

  const modifyFormFields = (remove) => {
    if(remove && !count) return;

    let newCount = remove ? count - 1 : count + 1;
    if (minValue && newCount < minValue) newCount = minValue;
    if (maxValue && newCount > maxValue) newCount = maxValue;

    setCount(newCount);
    onChange(newCount);
  };

  return (
    <label className={labelClassName}>
      {label || ""}
      <div className={counterContainer}>
        <IconButton
          className={counterButton}
          icon={<p>-</p>}
          onClick={() => modifyFormFields(true)}
        />
        <input
          name={inputName}
          type="text"
          className={counterDisplay + " " + (errMessage ? "counter-error" : "")}
          value={count}
          onChange={(e) => setPositiveCount(e.target.value)}
        />
        <IconButton className={counterButton} icon={<p>+</p>} onClick={() => modifyFormFields()} />
      </div>
      {showAmount ? <p>
        Amount: <span>{showAmount}</span>
      </p> : ""}
    </label>
  );
};

CounterInput.propTypes = {
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  counterContainer: PropTypes.string,
  counterButton: PropTypes.string,
  counterDisplay: PropTypes.string,
  onChange: PropTypes.func,
  inputName: PropTypes.string,
};

export default CounterInput;
